import { CSSProperties } from "react";

export const DEFAULT_DND_ITEM_STYLES: CSSProperties = {
    padding: "0.5rem 1rem",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem"
};

export const ITEM_BORDER_STYLE = {
    border: "1px solid #dee2e6"
};

export const PLACEHOLDER_BORDER_STYLE = {
    border: "dashed 1px blue"
};